module.exports = __webpack_public_path__ + "img/clear.f4ef7641.svg";